import { observable } from 'mobx';

import { BaseStore } from './BaseStore';
import type { RootStore } from './RootStore';
import type { Configuration } from '~/models/configuration';

export class ConfigurationStore extends BaseStore {
  @observable
  configuration: Configuration;

  constructor(rootStore: RootStore, configuration: Configuration) {
    super(rootStore);
    this.configuration = configuration;
  }
}
